import { IUpdateItemFolhaPagamentoUseCase } from "../../../presentation/useCases/update/update_item_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateItemFolhaPagamentoUseCase
 */

export class UpdateItemFolhaPagamentoUseCase implements IUpdateItemFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async updateItemFolhaPagamento(
    idItemFolhaPagamento: number,
    tituloConta: string | null,
    idSubconta: number | null,
    formaPagamento: string | null,
    valorPagar: number | null,
    observacaoFolha: string | null,
  ): Promise<void> {
    await this.repository.updateItemFolhaPagamento(
      idItemFolhaPagamento,
      tituloConta,
      idSubconta,
      formaPagamento,
      valorPagar,
      observacaoFolha,
    );
  }
}
